import { AppRegistry, Platform } from "react-native";

import App from "app";
import WebFonts from "app/fonts.web";
import * as analytics from "./utils/analytics/ga";

const appName = "sentimeter";

AppRegistry.registerComponent(appName, () => App);

if (Platform.OS === "web") {
  analytics.initializeAnalytics(process.env.REACT_APP_ENV);

  AppRegistry.runApplication(appName, {
    rootTag: document.getElementById("root"),
  });

  // Create stylesheet
  const styleSheet = `${WebFonts}`;
  const style = document.createElement("style");
  style.type = "text/css";
  if (style.styleSheet) {
    style.styleSheet.cssText = styleSheet;
  } else {
    style.appendChild(document.createTextNode(styleSheet));
  }

  // Inject stylesheet
  document.head.appendChild(style);
}
